<div class="donut-chart">
  @if (title) {
    <div class="card-head">
      <div class="card-title">{{ title }}</div>
    </div>
  }
  <highcharts-chart
    [options]="chartOptions"
    style="width: 100%; height: auto; display: block"
  ></highcharts-chart>
</div>
